import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import AppShell from "@/components/AppShell";
import { Loader2 } from "lucide-react";

export default function Protected({ children, requirePlatform, requireModule, requireAdmin }) {
  const { session } = useAuth();
  if (session === null) {
    return <div className="flex min-h-screen items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-slate-400" /></div>;
  }
  if (!session) return <Navigate to="/login" replace />;

  if (requirePlatform) {
    if (!session.platform_role) return <Navigate to="/" replace />;
    return <AppShell>{children}</AppShell>;
  }
  if (session.platform_role && !session.impersonating) return <Navigate to="/platform" replace />;

  const mods = session.available_modules || [];
  if (requireModule && !mods.includes(requireModule)) {
    if (mods.length === 0) return <Navigate to="/billing" replace />;
    return <Navigate to="/" replace />;
  }
  if (requireAdmin && !session.roles?.includes("tenant_admin")) return <Navigate to="/" replace />;

  return <AppShell>{children}</AppShell>;
}
